// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateDocumentAggregatorDto
 */
export interface ICreateDocumentAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof ICreateDocumentAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateDocumentAggregatorDto
     */
    document_type?: ICreateDocumentAggregatorDtoDocumentTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICreateDocumentAggregatorDtoDocumentTypeEnum {
    RECEIPT = 'RECEIPT',
    STATEMENT = 'STATEMENT',
    LOCKBOX = 'LOCKBOX',
    LETTER_OF_MEDICAL_NECESSITY = 'LETTER_OF_MEDICAL_NECESSITY'
}


/**
 * Check if a given object implements the ICreateDocumentAggregatorDto interface.
 */
export function instanceOfICreateDocumentAggregatorDto(value: object): value is ICreateDocumentAggregatorDto {
    return true;
}

export function ICreateDocumentAggregatorDtoFromJSON(json: any): ICreateDocumentAggregatorDto {
    return ICreateDocumentAggregatorDtoFromJSONTyped(json, false);
}

export function ICreateDocumentAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateDocumentAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'document_type': json['document_type'] == null ? undefined : json['document_type'],
    };
}

export function ICreateDocumentAggregatorDtoToJSON(json: any): ICreateDocumentAggregatorDto {
    return ICreateDocumentAggregatorDtoToJSONTyped(json, false);
}

export function ICreateDocumentAggregatorDtoToJSONTyped(value?: ICreateDocumentAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'document_type': value['document_type'],
    };
}

